import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { LoadQuickLinks, LoadQuickLinksSuccess, LoadRoleMenus, LoadRoleMenusSuccess, LoadUserApplications, LoadUserApplicationsSuccess,
    LoadUserCostCenters, LoadUserCostCentersSuccess, LoadUserEvents, LoadUserEventsSuccess } from './userMap.action';
import { mergeMap, map, catchError, switchMap } from 'rxjs/operators';
import { UserMappingService } from '../providers/user/user-mapping.service';
import { CostCenters } from '../shared/models/UserMapping/UserMapping.interface';
import { GeneralService } from '../providers/general/general.service';
import { Application } from '../shared/models/header/application.interface';
import { SidebarService } from 'src/app/providers/sidebar/sidebar.service';
import { Menu } from '../shared/models/sidebar/sidebar.interface';
import { RolesService } from '../providers/setups/roles/roles.service';
import { EmpEvent } from '../shared/models/setups/roles/roleEvent.interface';
import { QuickLinks } from '../shared/models/header/quicklinks.interface';

@Injectable()

export class UserMappingEffect {
    result: any;
    marqueeText: any;
    constructor(private actions$: Actions, private userMap: UserMappingService, private genserv: GeneralService,
                private sideServ: SidebarService, private roles: RolesService) {}

    LoadUserCostCenters$ = createEffect(() =>
    this.actions$.pipe(
        ofType(LoadUserCostCenters),
        mergeMap(() =>
            this.userMap.UserCostCenters().pipe(
                map((data: CostCenters[]) => LoadUserCostCentersSuccess({ CostCenters: data }))
            )
        )
    )
    ); // end of effect

    LoadUserApplications$ = createEffect(() =>
                this.actions$.pipe(
                    ofType(LoadUserApplications),
                    mergeMap(() =>
                        this.genserv.getApplications().pipe(
                            map((data: Application[]) => LoadUserApplicationsSuccess({Applications: data}))
                        )
                    )
                )
    );

    LoadRoleMenu$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadRoleMenus),
            mergeMap((res) => {
                return this.sideServ.RoleMenu(res.path).pipe(
                    map((data: Menu[]) => LoadRoleMenusSuccess({ RoleMenus: data }))
                );
            }
            )
        )
    );

    LoadEmpEvents$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadUserEvents),
            mergeMap((res) => {
                return this.roles.getRoleEvent().pipe(
                    map((data: EmpEvent[]) => LoadUserEventsSuccess({ Events: data }))
                );
            }
            )
        )
    );

    LoadQuickLinks$ = createEffect(() =>
        this.actions$.pipe(
            ofType(LoadQuickLinks),
            mergeMap((res) => {
                return this.sideServ.getQuickLinks().pipe(
                    map((data: QuickLinks[]) => LoadQuickLinksSuccess({ QuickLinks: data }))
                );
                this.result = res;
                this.marqueeText = this.result.marquee;
                console.log('this.marqueeText-',this.marqueeText)
            }
            )
        )
    );
}
